var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"content"},[(!_vm.notVisibleRoutes())?_c('app-bar'):_vm._e(),_c('router-view')],1),(!_vm.notVisibleRoutes())?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }